export default {
  login: {
    title: '登录我的页面',
    double_check_text: '输入的信息有误，请确认后重试。',
    id_email: 'ID/电子邮件地址',
    password: '密码',
    password_display: '显示密码',
    password_no_display: '未显示密码',
    login: '登录',
    keep_login_text: '保留登录信息',
    forgot_password_text: '忘记密码',
    contact_us: '如未注册，请联系我们',
    asuene_service_outline: '二氧化碳可视化云服务“ASUENE”',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: '专门面向GX/ESG人才的求职平台“ASUENE CAREER”',
    corporate_page: '企业HP',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
